<template>
    <div class="login-wrapper d-flex justify-content-center w-100">
      <!-- Right Section: Login Form -->
      <div class="col-12 d-flex flex-column justify-content-center align-items-center">
        <div class="form-container-wrap rounded">
           <div class="form-container">
            <h3 class="fw-bold fs-1 text-center loginTitle mb-3">
              Καλώς ήρθατε
            </h3>
            <p class="text-center fs-6 mb-4">
              Σύνδεση στην Πλατφόρμα Ηλεκτρονικού Εισιτηρίου του Δήμου Νέας Ιωνίας
            </p>
            <form class="row g-1 p-3 p-md-2" @submit.prevent="login" @keydown.enter.prevent="login" method="POST" action="/backend/login">
              <div class="col-12">
                <div class="mb-2">
                  <label class="form-label fw-bold">Διεύθυνση Email</label>
                  <input type="email" class="form-control form-control-md login-email" placeholder="name@example.com" name="username" v-model="username">
                </div>
              </div>
              <div class="col-12">
                <div class="">
              
                  <label class="form-label fw-bold">Κωδικός πρόσβασης</label>
                  <div class="d-flex justify-content-center align-items-center position-relative">
                    <input id="showPassword" type="password" v-model="password" class="form-control form-control-md login-password" placeholder="********">
                    <span class="showPasswordIcon" @click="showPass()"><i class="icofont-eye-alt"></i></span>
                  </div>
                </div>
              </div>
    
              <div class="col-12">
                <div class="form-label">
                    <span class="">
                      <a class="reset-password" @click.prevent="goToResetPassword()" href="#">Ξέχασα τον κωδικό μου</a>
                    </span>
                  </div>
              </div>
    
              <div class="col-12 text-center mt-4 mb-2">
                <button class="fw-bold btn text-uppercase btn-login" alt="signin" @click="login">ΣΥΝΔΕΣΗ</button>
              </div>
    
            </form>
    
            <div class="error-div" v-if="errorMessage">
              <p>{{ errorMessage }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
<script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  import { useRouter } from 'vue-router';
  import { login as authLogin } from '../services/auth.js';
  import { getAppInfo } from '@/services/appInfo.js';
  import { fetchUserInfo } from '@/services/user';

  const router = useRouter();

  const username = ref('');
  const password = ref('');
  const rememberMe = ref(0);
  const errorMessage = ref(null);
  const appInfo = ref(null);

  const handleKeyPressed = (event) => {
    if (event.key === 'Enter') {
      document.querySelector('.btn-login')?.click();
    }
  };

  onMounted(async () => {
    document.addEventListener('keyup', handleKeyPressed);
  });

  onUnmounted(() => {
    document.removeEventListener('keyup', handleKeyPressed);
  });

  const login = async () => {
    errorMessage.value = null;

    if (!username.value || !password.value) return;

    try {
      const response = await authLogin(username.value, password.value);

      if (response.data?.success) {
        const token = response.data?.data?.token?.plainTextToken;
        if (token) localStorage.setItem('api_token', token);

        window.dispatchEvent(new Event('auth-changed'));

        const user = (await fetchUserInfo()).data.info;

        if (user.usertype_id === 1) {
          router.push({ name: 'Events' });
        } else {
          router.push({ name: 'Home' });
        }

      } else {
        errorMessage.value = response.data.message;
      }
    } catch (e) {
      errorMessage.value = 'Λάθος στοιχεία σύνδεσης';
    }
  };

  const showPass = () => {
    const passField = document.getElementById('showPassword');
    if (passField) {
      passField.type = passField.type === 'password' ? 'text' : 'password';
    }
  };

  const goToResetPassword = () => router.push('/reset-password');
  const goToAdminPage = () => router.push('/events');
</script>

  
  <style scoped>
  .loginTitle{
    text-shadow: 1px 0px;
  }
  .Loginlogo{
    height: 200px;
  }
  
  

  .right-section {
    width: 100%;
    padding: 2rem;
  }
  
  .secondLogo{
      height: 290px !important;
  }

  .form-container-wrap{
    background-color: #fff;
    padding: 50px;
  }

  .form-container {
    width: 100%;
    max-width: 400px;
  }
  
  /* Input fields styling */
  .login-email,
  .login-password {
    width: 100%;
    /* box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); */
    letter-spacing: 2px;
  }
  
  /* Show password icon */
  .showPasswordIcon {
    color: #8d8d8d;
    font-size: large;
    position: absolute;
    right: 6%;
  }
  
  /* Error message styling */
  .error-div {
    color: red;
    text-align: center;
  }
  
  /* Adjust the button style */
  .btn-login {
    background-color: #af0036;
    color: #fff;
    font-size: 1.25rem;
    width: 100%;
    border-radius: 30px;
  }
  
  .btn-login:hover{
    color:#ffffff;
    background-color: #888888;
  }

  .reset-password{
    text-decoration: underline;
    color:gray;
    font-size: 12px;
  }
  
  /* Responsive behavior for smaller screens */
  @media (max-width: 768px) {
    .login-wrapper {
      min-height: calc(100vh - 177px);
    }
    .Loginlogo{
      height: 160px;
    }
    .btn-login {
      padding: 5px 20px;
    }
    .justify-content-center-mob{
      justify-content: center;
    }
    
    .form-container-wrap{
      padding: 20px 8px; 
    }

  }
  </style>
  
  